import {
   GET_COUPON_LIST,
   GET_DAILYCHECK_HISTORY,
   GET_DAILYCHECK_INFO,
   GET_DEPOSITDATA,
   GET_DEPOSIT_SUM,
   GET_WITHDRAWDATA,
   GET_WITHDRAW_SUM,
   GET_EVENT_LIST,
   GET_EVENT_TYPE,
   GET_EXCHANGEDATA,
   GET_HISTORIES,
   GET_LOTTERY_DATA,
   GET_MESSAGEDATA,
   GET_PARTNERS,
   GET_QUESTION_LIST,
   GET_ROULETTE_DATA,
   GET_ROULETTE_RULES, 
   GET_NOTICES,
   GET_POINT_HISTORY,
   SET_DETAIL_NOTICE,
   SET_DETAIL_EVENT,
   GET_BONUS, 
   GET_REALTIME_DEPOSITE,
   GET_REALTIME_WITHDRAW
} from '../actions/types';

const initialState = {
   language: "한국어",
   slideBar: true,
   message: {
      notes: [],
      unreadNotes: []
   },
   deposit: {
      data: []
   },
   withdraw: {
      data: []
   },
   realWithdraw:{
      data: []
   },
   realDeposite:{
      data: []
   },
   pointHistory: [],
   pointexchange: {
      data: [],
      sum: {
         today: 0,
         thisMonth: 0,
         lastMonth: 0
      }
   },
   custommercenter: {
      data: []
   },
   dailycheck: {
      histories: [],
      currentMonthCount: 0,
      depositLimit:0,
      aDayMoney: 0,
      bDayMoney: 0,
      cDayMoney: 0,
      daily_event_setting:true
   },
   lottery: {
      history: [],
      leftCount: 0
   },
   roulette: {
      history: [],
      leftCount: 0,
      roulette: {}
   },
   coupon: {
      list: []
   },
   event: {
      types: [],
      posts: []
   },
   notice: {
      notices: []
   },
   bonusList: [],
   histories: [],
   partners: [],
   historyType: "prematch",
   detailNoticeId: -1,
   detailEventId: -1,
}

export default function (state = initialState, action) {
   switch (action.type) {
      case "change_language":
         return {
            ...state,
            language: action.payload
         }
      case "change_slide_status":
         return {
            ...state,
            slideBar: action.payload
         }
      case GET_MESSAGEDATA:
         return {
            ...state,
            message: {
               ...state.message,
               notes: action.payload.notes,
               unreadNotes: action.payload.unreadNotes
            }
         }
      case GET_REALTIME_DEPOSITE:
         return {
            ...state,
            realDeposite: {
               ...state.realDeposite,
               data: action.payload
            }
         }
      case GET_REALTIME_WITHDRAW:
         return {
            ...state,
            realWithdraw: {
               ...state.realWithdraw,
               data: action.payload
            }
         }
      case GET_DEPOSITDATA:
         return {
            ...state,
            deposit: {
               ...state.deposit,
               data: action.payload
            }
         }
      case GET_WITHDRAWDATA:
         return {
            ...state,
            withdraw: {
               ...state.withdraw,
               data: action.payload
            }
         }
      case GET_POINT_HISTORY:
         return {
            ...state,
            pointHistory: action.payload
         }
      case GET_EXCHANGEDATA:
         return {
            ...state,
            pointexchange: {
               ...state.pointexchange,
               data: action.payload
            }
         }
      case GET_DEPOSIT_SUM:
         return {
            ...state,
            deposit: {
               ...state.deposit,
               sum: action.payload
            }
         }
      case GET_WITHDRAW_SUM:
         return {
            ...state,
            withdraw: {
               ...state.withdraw,
               sum: action.payload
            }
         }
      case GET_HISTORIES:
         // console.log(action.payload)
         return {
            ...state,
            histories: action.payload.bets,
            historyType: action.payload.type
         }
      case GET_PARTNERS:
         return {
            ...state,
            partners: action.payload
         }
      case GET_QUESTION_LIST:
         return {
            ...state,
            custommercenter: {
               ...state.custommercenter,
               data: action.payload
            }
         }
      case GET_DAILYCHECK_HISTORY:
         return {
            ...state,
            dailycheck: {
               ...state.dailycheck,
               depositLimit: action.payload.depositLimit,
               aDayMoney: action.payload.aDayMoney,
               bDayMoney: action.payload.bDayMoney,
               cDayMoney: action.payload.cDayMoney,
               currentMonthCount: action.payload.currentMonthAttendanceCount,
               histories: action.payload.history,
               daily_event_setting: action.payload.daily_event_setting


            }
         }
      case GET_DAILYCHECK_INFO:
         return {
            ...state,
            dailycheck: {
               ...state.dailycheck,
               attendance: action.payload,
            }
         }
      case GET_LOTTERY_DATA:
         return {
            ...state,
            lottery: {
               ...state.lottery,
               history: action.payload.history,
               leftCount: action.payload.leftCount
            }
         }
      case GET_ROULETTE_DATA:
         return {
            ...state,
            roulette: {
               ...state.roulette,
               history: action.payload.history,
               leftCount: action.payload.leftCount
            }
         }
      case GET_ROULETTE_RULES:
         return {
            ...state,
            roulette: {
               ...state.roulette,
               roulette: action.payload.roulette
            }
         }
      case GET_COUPON_LIST:
         return {
            ...state,
            coupon: {
               ...state.coupon,
               list: action.payload
            }
         }
      case GET_EVENT_TYPE:
         return {
            ...state,
            event: {
               ...state.event,
               types: action.payload
            }
         }
      case GET_EVENT_LIST:
         return {
            ...state,
            event: {
               ...state.event,
               posts: action.payload
            }
         }
      case GET_NOTICES:
         return {
            ...state,
            notice: {
               ...state.event,
               notices: action.payload
            }
         }
      case SET_DETAIL_NOTICE:
         return {
            ...state,
            detailNoticeId: action.payload,
         }
      case SET_DETAIL_EVENT:
         return {
            ...state,
            detailEventId: action.payload,
         }
      case GET_BONUS:
         return {
            ...state,
            bonusList: action.payload,
         }
      default:
         return state;
   }
}




// WEBPACK FOOTER //
// ./src/common/reducers/moreReducer.js